export enum MassiveNewRoutingCreateFlags {
  FIRST_FLAG,
  BACK_TO_DELIVERIES,
  CONTINUE_TO_CREATE_SERVICE,
  CREATE_SERVICES,
  ROUTING_FAIL,
  ROUTING_PACKAGES
}
